import { Box } from '@mui/material';
import React from 'react';
import UploadImage from '../components/upload-image';
import { common } from '@mui/material/colors';
interface IProps {
    name: string;
    options: { label: string }[];
    maxFileSize: number;
}
const QuestionImageWithTitle: React.FC<IProps> = ({
    name,
    options,
    maxFileSize,
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: [
                    'center',
                    'flex-start',
                    'flex-start',
                    'space-around',
                    'space-around',
                ],
                alignItems: 'baseline',
                gap: ['1.5rem', '2rem', '2rem', '0rem', '0rem'],
                flexWrap: 'wrap',
            }}
        >
            {options.map((item, index) => {
                return (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Box
                            sx={{
                                fontSize: [
                                    '1rem',
                                    '1.2rem',
                                    '0.9rem',
                                    '1.4rem',
                                    '1.4rem',
                                ],
                                color: [common.white, '#00000080'],
                                fontWeight: ['nomarl', 700],
                                marginBottom: [
                                    '1rem',
                                    '1rem',
                                    '1rem',
                                    '1.5rem',
                                    '1.5rem',
                                ],
                            }}
                        >
                            {item.label}
                        </Box>
                        <UploadImage
                            name={`${name}.${index}.image`}
                            maxFileSize={maxFileSize}
                        />
                    </Box>
                );
            })}
        </Box>
    );
};

export default QuestionImageWithTitle;
